import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './SubNavSection.scss'

import { NavLink } from 'react-router-dom'

const SubNavSection = ({ path, exact, label, onClick, icon }) => {
	return (
		<div styleName="section">
			<NavLink
				to={path}
				className={styles.link}
				activeClassName={styles.active}
				exact={exact}
			>
				{icon ? (
					<i className="material-icons" styleName="icon">
						{icon}
					</i>
				) : null}
				<div styleName="label">{label}</div>
			</NavLink>
		</div>
	)
}

SubNavSection.propTypes = {
	path: React.PropTypes.string,
	icon: React.PropTypes.string,
	label: React.PropTypes.string,
	notifications: React.PropTypes.number
}

export default CSSModules(SubNavSection, styles)



// WEBPACK FOOTER //
// ./src/components/Navigation/SubNavSection.js